import { getImageOriginalV1, getImageResizedV1 } from '../apis';
import { actionFactory } from '../infrastructure/actionFactory';

export const getImageResized = (imageId: string) =>
  actionFactory('IMAGE_RESIZED_GET', getImageResizedV1(imageId));

export const getImageOriginal = (imageId: string) =>
  actionFactory('IMAGE_ORIGINAL_GET', getImageOriginalV1(imageId));
